import { Routes } from '@angular/router';
import { UserListComponent } from './components/user-list/user-list.component';
// import { LoginComponent } from './components/login/login.component';
import { LandingComponent } from './components/landing/landing.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { RoleListComponent } from './components/role-list/role-list.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
import { authGuard } from './guards/auth.guard';
// import { loginGuard } from './guards/auth.guard';
import { MasterClientListComponent } from './components/master/master-client-list.component';
import { MasterRoleListComponent } from './components/master/master-role-list.component';
import { MasterUserListComponent } from './components/master/master-user-list.component';
import { ProfileComponent } from './components/profile/profile.component';

export const routes: Routes = [
  { path: '', component: LandingComponent },
  // { path: 'login', component: LoginComponent, canActivate: [loginGuard] },
  { path: 'portal/user-management/users/verify-email', component: VerifyEmailComponent },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [authGuard],
    children: [
      { path: 'users', component: UserListComponent },
      { path: 'roles', component: RoleListComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'master/clients', component: MasterClientListComponent },
      { path: 'master/roles', component: MasterRoleListComponent },
      { path: 'master/users', component: MasterUserListComponent }
    ]
  }
];
